import clsx from 'clsx';
import { useState } from 'react';
import { useRouter } from 'next/router';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import PageLayout from '../components/PageLayout';
import { ReactComponent as TiltedArrow } from '../public/images/blue-down-arrow.svg';
import createApolloClient from '../api';
import getAllTemplateTopics from '../api/queries/template/templateTopics/getAllTemplateTopics';
import getMenu from '../api/queries/menus/getMenu';
import Breadcrumb from '../components/Breadcrumb';
import sanitizeHTML from '../utils/sanitiseHTML';
import templatesData from '../utils/data/templates';
import Reviews from '../components/Reviews';

const client = createApolloClient();

const Templates = ({ templateTopics, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData }) => {
  const [topicOpen, setTopicOpen] = useState('');
  const { query } = useRouter();
  const router = useRouter();
  let data = templateTopics.nodes;
  const type = query.type;
  const pageName = {
    pageBy: {
      title: 'Templates',
      slug: 'templates',
    },
  };

  if (type) {
    data = data.filter((o) => o.slug === type);
  }

  if (data.length === 0) {
    router.push({
      pathname: '/page-not-found',
    });
  }
  let yoastSeo = {};
  if (type) {
    yoastSeo = data[0].seo;
  } else {
    yoastSeo = {
      title: 'Free Legal Letter Templates and Examples | Monaco Solicitors',
    };
  }
  const indexStatus = {
    "indexPage": true
  }

  return (
    <PageLayout
      menuData={desktopHeaderData}
      aboutMenuData={aboutMenuData}
      serviceMenuData={serviceMenuData}
      toolsMenuData={toolsMenuData}
      seo={yoastSeo}
      title="Templates"
      indexStatus={indexStatus}
    >
      <Breadcrumb data={pageName} />

      <div className="templates">
        <div className="templates__introduction">
          {templatesData.map((obj) => {
            return (
              obj.type === type && (
                <>
                  <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(obj.title) }} />
                  <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(obj.subtitle) }} />
                </>
              )
            );
          })}
          {query && !type && (
            <>
              <h1>Free Legal Letter Templates and Examples</h1>
              <p>
                The <b>legal letter templates</b> and <b>example documents</b> listed below should
                help you negotiate a decent settlement agreement (aka compromise agreement) with
                your employer. They will think that you've hired lawyers!
              </p>
            </>
          )}
          <div className="section__video">
            <div className="section__video__wrapper">
              <LiteYouTubeEmbed
                id="FEV1NFZeUPE" // Default none, id of the video or playlist
                adNetwork={true} // Default true, to preconnect or not to doubleclick addresses called by YouTube iframe (the adnetwork from Google)
                playlist={false} // Use  true when your ID be from a playlist
                playlistCoverId="L2vS_050c-M" // The ids for playlists did not bring the cover in a pattern to render so you'll need pick up a video from the playlist (or in fact, whatever id) and use to render the cover. There's a programmatic way to get the cover from YouTube API v3 but the aim of this component is do not make any another call and reduce requests and bandwidth usage as much as possibe
                poster="hqdefault" // Defines the image size to call on first render as poster image. Possible values are "default","mqdefault",  "hqdefault", "sddefault" and "maxresdefault". Default value for this prop is "hqdefault". Please be aware that "sddefault" and "maxresdefault", high resolution images are not always avaialble for every video. See: https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
                title="YouTube Embed" // a11y, always provide a title for iFrames: https://dequeuniversity.com/tips/provide-iframe-titles Help the web be accessible ;)
                noCookie={true} // Default false, connect to YouTube via the Privacy-Enhanced Mode using https://www.youtube-nocookie.com
                autoplay={true}
              />
            </div>
          </div>
        </div>

        <Reviews>
          <h3>
            Rated 4.8 Stars in Over 1,000 <a href="/testimonials">Reviews</a>
          </h3>
          <p className="subtitle_1">
            You can rest assured that, because we represent individuals only, there is no{' '}
            <span>conflict of interest</span>
          </p>
        </Reviews>

        {templatesData.map((obj) => {
          return (
            obj.type === type && (
              <>
                <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(obj.content) }} />
              </>
            )
          );
        })}

        <div className="templates__list">
          {data.map((templateTopic, i) => {
            const classes = clsx({
              'templates__list__topic--open': topicOpen === i,
            });

            const handleChevronOnClick = (i) => () => {
              return topicOpen === i ? setTopicOpen('') : setTopicOpen(i);
            };

            return (
              <div className={`templates__list__topic ${classes}`}>
                <div className="templates__topic__title">
                  <h4>{templateTopic.name}</h4>
                  {data.length > 1 && <TiltedArrow onClick={handleChevronOnClick(i)} />}
                </div>

                <p>{templateTopic.description}</p>
                {data.length > 1 && topicOpen === i && (
                  <div className="templates__list__by-topic">
                    <ul>
                      {templateTopic.templates.nodes.map((template) => {
                        return (
                          <li className="templates__list__template">
                            <div className="templates__template__content">
                              <h5>{template.title}</h5>
                              <div
                                dangerouslySetInnerHTML={{ __html: sanitizeHTML(template.content) }}
                              />
                              <a
                                className="button"
                                href={`/${templateTopic.slug}/templates/${template.slug}`}
                              >
                                View Template
                              </a>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
                {data.length === 1 && (
                  <div className="templates__list__by-topic">
                    <ul>
                      {templateTopic.templates.nodes.map((template) => {
                        return (
                          <li className="templates__list__template">
                            <div className="templates__template__content">
                              <h5>{template.title}</h5>
                              <div
                                dangerouslySetInnerHTML={{ __html: sanitizeHTML(template.content) }}
                              />
                              <a
                                className="button"
                                href={`/${templateTopic.slug}/templates/${template.slug}`}
                              >
                                View Template
                              </a>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </PageLayout>
  );
};

export default Templates;

export async function getStaticProps() {
  const serviceMenuId = process.env.APP_ENV === 'stage' ? 'dGVybTo2Mg==' : 'dGVybTo2Ng==';
  const { data } = await client.query(getAllTemplateTopics());
  const { templateTopics } = data;
  const desktopHeaderData = await client.query(getMenu('dGVybToyNQ=='));
  const aboutMenuData = await client.query(getMenu('dGVybTo1NQ=='));
  const serviceMenuData = await client.query(getMenu(serviceMenuId));
  const toolsMenuData = await client.query(getMenu('dGVybTo1Ng=='));

  return {
    props: { templateTopics, desktopHeaderData, aboutMenuData,serviceMenuData, toolsMenuData },
    revalidate: 10,
  };
}
